import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, Subscription, Subject, of } from 'rxjs';
import { takeUntil, switchMap } from 'rxjs/operators';
import { SecureStorageService } from './core/validators/secure-storage.service';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { LoadingConst } from './core/constants/color-loading';
import { ParametersService } from './core/services/parameters.service';
import { IRequest } from './core/interfaces/parameters';
import { VersionCheckService } from './core/services/version-check.service';

const PrimaryColor = LoadingConst.colorPrimary;
const SecondaryColor = LoadingConst.colorSecondary;

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  title = 'MEDIANET_ONB_FE';
  IsInit: boolean = false;
  private destroy$ = new Subject<void>();

  public primaryColour = PrimaryColor;
  public secondaryColour = SecondaryColor;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;

  constructor(
    private activatedRoute: ActivatedRoute, 
    private router: Router,
    private cdr: ChangeDetectorRef,
    private secureStorageService: SecureStorageService,
    private parametersService: ParametersService,
    private versionCheckService: VersionCheckService
  ){}

  ngOnInit() {
    this.versionCheckService.initVersionCheck();
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        window.scrollTo(0, 0);
      });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.handleNavigation();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private handleNavigation() {
    const rutaActual = this.router.url;
    
    if (rutaActual === '/') {
      this.clearStorage();
      this.navigateToMaintenance();
    } else {
      this.activatedRoute.queryParams.pipe(
        takeUntil(this.destroy$),
        switchMap(queryParams => {
          if (queryParams['mnt-uuid-cp']) {
        
            // Decodificar Base64 antes de desencriptar
            const decodedBase64 = this.secureStorageService.decryptBase64(queryParams['mnt-uuid-cp']);
        
            // Desencriptar la cadena decodificada
            const safeResponse = JSON.parse(this.secureStorageService.decrypt(decodedBase64.replace(/"/g, '')));
        
            if (queryParams['step-avalible'] == "true") {
              this.secureStorageService.saveData("step-avalible", "true");
            } else {
              this.secureStorageService.saveData("step-avalible", "false");
            }
        
            return this.getParameters({ CompanyId: safeResponse.companyId, TrackingId: safeResponse.idTracking });
          } 
          this.navigateToMaintenance();
          return of(null);
        })
      ).subscribe();
    }
  }

  private clearStorage() {
    this.secureStorageService.removeData("designConfig");
    this.secureStorageService.removeData("IdTracking");
    this.secureStorageService.removeData("CompanyId");
  }

  getParameters(request: IRequest) {
    return this.parametersService.getParameters(request).pipe(
      takeUntil(this.destroy$),
      switchMap(data => {
        if (data?.Succeeded) {
          const companyId = data.Data.CompanyId;
          const trakingId = data.Data.TrackingId;
          const parametros = data.Data.Parameters;
          const datosEntrega = JSON.stringify(data.Data.DatosEntregaEquipo);

          if (companyId) {
            this.secureStorageService.saveData("CompanyId", companyId);
            this.secureStorageService.saveData("IdTracking", trakingId);
            this.secureStorageService.saveData("DatosEntrega", datosEntrega);
          } else {
            this.navigateToMaintenance();
          }

          if (parametros) {
            this.secureStorageService.saveData("designConfig", JSON.stringify(parametros));
            this.applyConfigurations(parametros);
          } else {
            this.navigateToMaintenance();
          }
        } else {
          this.navigateToMaintenance();
        }
        return of(null);
      })
    );
  }

  private navigateToMaintenance() {
    this.router.navigate(['/error/not-access']).then(() => {

      this.IsInit = true;
      this.cdr.detectChanges();
    });
  }

  convertArrayToObject(array: any) {
    return array.reduce((result: any, item: any) => {
      result[item.Parametro] = item.Valor;
      return result;
    }, {});
  }

  applyConfigurations(config: any) {
    if (!config) return;
    document.documentElement.style.setProperty('--color-primario', config.COLOR_TEMA_PRIMARIO);
    document.documentElement.style.setProperty('--color-secundario', config.COLOR_TEMA_SECUNDARIO);
    document.documentElement.style.setProperty('--color-terceario', config.COLOR_TEMA_TERCIARIO);
    this.IsInit = true;
    this.cdr.detectChanges();
  }
}
